import axios from '@/lib/axios';

export const recentPollsApi = (entitySlug, params) => axios.get(`/api/${entitySlug}/polls`, { params });
export const getPollDetailsApi = (entitySlug, id) => axios.get(`/api/${entitySlug}/polls/${id}`);
export const pollStopAPi = (entitySlug, id) => axios.post(`/api/${entitySlug}/polls/${id}/stop`);
export const pollStartAPi = (entitySlug, id) => axios.post(`/api/${entitySlug}/polls/${id}/start`);
export const answerDemographics = (payload) => axios.post('/api/user/demographics', payload);
export const createPoll = (entitySlug, payload) => axios.post(`/api/${entitySlug}/polls`, payload);
export const getDemographics = () => axios.get('/api/demographics');
export const pollPublishApi = (entitySlug, id) => axios.post(`/api/${entitySlug}/polls/${id}/publish`);
export const deletePollApi = (entitySlug, id) => axios.delete(`/api/${entitySlug}/polls/${id}`);
export const updatePollApi = (entitySlug, id, updateRequest) => axios.put(`/api/${entitySlug}/polls/${id}`, updateRequest);
export const registerEntityUserApi = (entitySlug, payload) =>
{
    return axios.post(`/api/${entitySlug}/user/register`, payload);
}
export const getPollToAnswerApi = (entitySlug, pollHash) =>
{
    return axios.get(`/api/${entitySlug}/poll/${pollHash}`);
};
export const pollAIQuestion = (entitySlug, payload) =>
{
    return axios.post(`/api/${entitySlug}/polls/aiquestion`, payload);
}
export const getAnswerPollApi = (entitySlug, id) =>
{
    return axios.get(`/api/${entitySlug}/polls/${id}`);
};
export const answerPollApi = (entitySlug, hashId, payload) =>
{
    return axios.post(`/api/${entitySlug}/poll/${hashId}/answer`, payload);
};
export const answerDemographicsApi = (entitySlug, hashId, payload) =>
{
    return axios.post(`/api/${entitySlug}/poll/${hashId}/demographics`, payload);
}

export const getPollResultsApi = (entitySlug, voterId) =>
{
    return axios.get(`/api/${entitySlug}/polls/${voterId}/results`);
}

export const getPlans= ()=> axios.get('/api/plans');

export const aiinsigtsApi = (entitySlug,payload) => axios.post(`/api/${entitySlug}/polls/aiinsigts`,payload);
export const aiPublicApi = (payload) => axios.post(`/api/chat-bot`,payload);

export const lookupPollByCode = (code) =>
    axios.get(`/api/vote/lookup/${encodeURIComponent(code)}`);
